<template>
  <div id="app">
    <cludo-vue>
      <template #default="{
        searchResult,
        filterParamaters,
        pageLoading,
        resultLoading,
      }">
        <cludo-vue-attr-filter />
        <section class="programmes">
          <!-- Main -->
          <div class="programmes__main">
            <!-- Meta -->
            <div v-if="!resultLoading && !pageLoading" class="programmes__meta">
              <!-- Results Count -->
              <results-count :totalResults="Number(searchResult?.TotalDocument)"
                :filterParamaters="filterParamaters" />

              <!-- Clear Filters -->
              <cludo-vue-clear-filters v-if="checkFilters(filterParamaters)"
                class="button button--small bg-bright-blue">
                Clear Filters
              </cludo-vue-clear-filters>
            </div>

            <!-- Search Results -->
            <template>
              <div v-if="pageLoading">
                <SearchLoader />
              </div>
              <template v-else>
                <cludo-vue-banners />
                <cludo-vue-results class="search-results" v-if="Number(searchResult?.TotalDocument) > 0">
                  <template #loading>
                    <SearchLoader />
                  </template>
                  <template #default="{ searchResult }">
                    <search-result :result="searchResult" />
                  </template>
                </cludo-vue-results>
                <search-no-results v-else :searchTerm="filterParamaters?.query" />
              </template>
            </template>
          </div>

          <!-- Sidebar -->
          <aside class="programmes__aside" role="complementary">
            <!-- Filters -->
            <div class="programmes__filters">
              <SearchFilters :filterParamaters="filterParamaters" :isFiltering="checkFilters(filterParamaters)"
                :loading="pageLoading  || resultLoading" :years="years" />
            </div>
          </aside>
        </section>
      </template>
    </cludo-vue>
  </div>
</template>

<script>
import ResultsCount from './components/ResultsCount.vue';
import SearchResult from './components/SearchResult.vue';
import SearchFilters from './components/SearchFilters.vue';
import SearchLoader from './components/SearchLoader.vue';
import SearchNoResults from './components/SearchNoResults.vue';
export default {
  components: {
    ResultsCount,
    SearchResult,
    SearchFilters,
    SearchLoader,
    SearchNoResults,
  },
  name: 'App',
  props: {
    years: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    isCheckBoxFilterSelected(checkboxFilter) {
      //Check if at least one filter is selected and that filter is not the default (highest) study year

      if (checkboxFilter?.length > 0) {
        const selectedCheckBox =
          checkboxFilter.filter((el) => el?.checked === true).length || 0;

        if (
          //If more than one filter is selected return two
          selectedCheckBox > 1
        ) {
          return true;
        } else if (
          selectedCheckBox === 1 &&
          checkboxFilter.filter((el) => el.name === `${this.years[0]}-entry`)[0]
            ?.checked === false
        ) {
          return true;
        }
        return false;
      }
    },

    checkFilters(filterParamaters) {
      if (filterParamaters?.searchFilter?.length > 0) {
        return true;
      }

      if (Object.keys(filterParamaters?.rangeFilter)?.length > 0) {
        return true;
      }

      if (this.isCheckBoxFilterSelected(filterParamaters?.checkboxFilter)) {
        return true;
      }

      if (filterParamaters.sortFilter?.length > 0) {
        return true;
      }

      if (filterParamaters.fieldFilter?.length > 0) {
        return true;
      }

      if (filterParamaters.query) {
        return true;
      }

      return false;
    },
  },
};
</script>

<style lang="scss">
@import 'scss/main';
</style>
